import { render, staticRenderFns } from "./WeeklyScheduleRightMenu.vue?vue&type=template&id=8f2e189a&scoped=true&"
import script from "./WeeklyScheduleRightMenu.vue?vue&type=script&lang=ts&"
export * from "./WeeklyScheduleRightMenu.vue?vue&type=script&lang=ts&"
import style0 from "./WeeklyScheduleRightMenu.vue?vue&type=style&index=0&id=8f2e189a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2e189a",
  null
  
)

export default component.exports